import { type MembroListaElettorale } from '@framework/api-client';
import {
  hasRichTextAdvanced,
  RichTextAdvancedRender,
  type IWidgetComponentProps,
} from '@framework/engine';
import { ModalButton } from '@framework/ui';
import { t } from 'i18next';
import styled from 'styled-components';
import { getDinamicButtonProps } from '../getModalButtoProps';
import type { ICandidateWidget } from '../ICandidateWidget';
import { CandidateMembersTableData } from './CandidateMembersTableData';

const paddingModal = 16;
const CandidateWidgetModalTableWrapper = styled.div`
  margin-inline: -${paddingModal}px;
`;

export interface ICandidateWidgetModalProps
  extends IWidgetComponentProps<ICandidateWidget> {
  handleSelect: () => void;
  handleCancel: () => void;
  handleOpen: () => void;
  setSelected: (member: MembroListaElettorale | null) => void;
  /**
   * Membro corrente esterno alla modal utile per modificare il testo del pulsante
   */
  currentMember: MembroListaElettorale | null;
  /**
   * Membro selezionato nella modal
   */
  selected: MembroListaElettorale | null;
  fieldName?: string;
}

/**
 * Modal per la selezione del candidato
 */
export function CandidateWidgetModal(props: ICandidateWidgetModalProps) {
  const {
    widget,
    handleSelect,
    handleCancel,
    handleOpen,
    setSelected,
    currentMember,
    selected,
  } = props;

  const isMemberSelected =
    (currentMember != null && Object.keys(currentMember).length > 0) ?? false;

  const { buttonText, icon } = getDinamicButtonProps(
    widget.buttonText,
    widget.buttonTextAfter,
    isMemberSelected,
  );

  // Manteniamo testo del pulsante interno statico (scelta Candidato)
  const okText =
    widget.buttonText && widget.buttonText.trim().length > 0
      ? widget.buttonText
      : t('widgets.candidate.select-button-text', 'Scegli');

  return (
    <ModalButton
      buttonChildren={buttonText}
      type="primary"
      size="large"
      disabled={props.readonly}
      fieldName={props.fieldName}
      modalProps={{
        title: (
          <RichTextAdvancedRender
            text={
              hasRichTextAdvanced(widget.modalTitle)
                ? widget.modalTitle
                : t(
                    'widgets.candidate.modal-select-member-title',
                    'Seleziona Membro',
                  )
            }
          />
        ),
        okText: okText,
        styles: {
          content: { padding: `${paddingModal}px` },
          body: { borderBottom: `1px solid #eee` },
        },
      }}
      onOk={handleSelect}
      onCancel={handleCancel}
      onOpen={handleOpen}
      style={{ flexGrow: 0 }}
      icon={icon}
    >
      <CandidateWidgetModalTableWrapper>
        <CandidateMembersTableData
          setSelected={setSelected}
          selected={selected}
          widget={widget}
        />
      </CandidateWidgetModalTableWrapper>
    </ModalButton>
  );
}
